import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    errors: {}
};

const actions = {
    send(context, payload) {
        return ApiService
            .post('feedback/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    }
};

const mutations = {
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
